import React from 'react';
import { InvoiceTemplateProps } from './types';
import Header from './primitives/Header';
import PatientInfo from './primitives/PatientInfo';
import ItemsTable from './primitives/ItemsTable';
import Totals from './primitives/Totals';
import Footer from './primitives/Footer';

export default function Template7_WithQRCode({ invoice, hospital }: InvoiceTemplateProps) {
  const qrData = `${window.location.origin}/invoices/${invoice.id}`;
  
  return (
    <div className="bg-white p-8 max-w-[210mm] mx-auto" style={{ minHeight: '297mm' }}>
      <div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white p-6 -mx-8 -mt-8 mb-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold mb-2">{hospital.name}</h1>
            <p className="text-sm">{hospital.address}</p>
            <p className="text-sm">{hospital.phone}</p>
          </div>
          {hospital.logo && (
            <img src={hospital.logo} alt={hospital.name} className="h-16 w-auto bg-white p-2 rounded" crossOrigin="anonymous" />
          )}
        </div>
      </div>
      
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">INVOICE</h2>
          <p className="text-sm text-gray-600">#{invoice.invoice_number}</p>
        </div>
        <div className="text-right">
          {/* QR Code Placeholder - In production, use qrcode.react library */}
          <div className="border-2 border-gray-300 p-2 inline-block">
            <div className="w-24 h-24 bg-gray-100 flex items-center justify-center text-xs text-gray-500">
              QR Code
              <br />
              Scan to Pay
            </div>
          </div>
        </div>
      </div>

      <PatientInfo invoice={invoice} layout="grid" />
      
      <ItemsTable items={invoice.items} variant="standard" headerColor="bg-gradient-to-r from-purple-600 to-blue-600" />
      
      <Totals invoice={invoice} layout="standard" showPaymentInfo={true} />
      
      <div className="mt-8 p-4 bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg">
        <p className="text-sm text-gray-700">
          <span className="font-semibold">Payment Methods:</span> Cash, Card, Mobile Banking (bKash, Nagad, Rocket)
        </p>
        <p className="text-sm text-gray-700 mt-2">
          <span className="font-semibold">Scan QR Code</span> for quick payment or to view invoice online
        </p>
      </div>
      
      <Footer variant="signature" notes={invoice.notes} />
    </div>
  );
}
